export default __webpack_public_path__ + "static/A8-1c57c1e0653264d76d79b7a8f1a73980.png";